(() => {
  document.addEventListener('click', (e) => {
    if (e.target.classList.contains('se-dropdown__button') || e.target.closest('.se-dropdown__button')) {
      const el = e.target.classList.contains('se-dropdown__button')
        ? e.target
        : e.target.closest('.se-dropdown__button')
      const dropdown = el.closest('.se-dropdown')
      const ev = new CustomEvent('dropdowntoggle', {
        detail: { el }
      })
      el.dispatchEvent(ev)
      dropdown.querySelector('ul').classList.toggle('se-hidden')
    }

    if (e.target.classList.contains('se-dropdown__item') || e.target.closest('.se-dropdown__item')) {
      const el = e.target.classList.contains('se-dropdown__item')
        ? e.target
        : e.target.closest('.se-dropdown__item')
      const dropdown = el.closest('.se-dropdown')
      const ev = new CustomEvent('dropdownchange', {
        detail: { el }
      })
      dropdown.dispatchEvent(ev)
      dropdown.querySelector('.se-dropdown__value').innerText = el.innerText
      dropdown.querySelector('ul').classList.toggle('se-hidden')
    }

    if (!e.target.classList.contains('se-dropdown') && !e.target.closest('.se-dropdown')) {
      document.querySelectorAll('.se-dropdown ul').forEach(ul => ul.classList.add('se-hidden'))
    }
  })

  const reposition = (wrapper, pos = -1) => {
    const spans = Array.from(wrapper.querySelectorAll('span'))
    spans.forEach(span => span.classList.remove('se-hidden'))
    spans.splice(pos === -1 ? spans.length - 1 : pos, 1)
    spans.forEach(span => span.classList.add('se-hidden'))
  }

  // these objects and their methods help with
  // displaying specific bets on specific markets
  // e.g. away odds on winner, or yes odds on btts, etc.
  const Winner = {
    init: (wrapper) => reposition(wrapper, 0),
    home: (wrapper) => reposition(wrapper, 0),
    away: (wrapper) => reposition(wrapper, 1),
    draw: (wrapper) => reposition(wrapper, -1)
  }
  const Btts = {
    init: (wrapper) => reposition(wrapper, 0),
    yes: (wrapper) => reposition(wrapper, 0),
    no: (wrapper) => reposition(wrapper, -1)
  }
  const Tts = {
    init: (wrapper) => reposition(wrapper, 0),
    home: (wrapper) => reposition(wrapper, 0),
    away: (wrapper) => reposition(wrapper, 1),
    draw: (wrapper) => reposition(wrapper, -1)
  }
  const DoubleChance = {
    init: (wrapper) => reposition(wrapper, 0),
    homeAway: (wrapper) => reposition(wrapper, 0),
    homeDraw: (wrapper) => reposition(wrapper, 1),
    drawAway: (wrapper) => reposition(wrapper, 2)
  }
  const TotalGoals = {
    init: (wrapper) => reposition(wrapper, 0),
    '05': (wrapper) => reposition(wrapper, 0),
    15: (wrapper) => reposition(wrapper, 1),
    25: (wrapper) => reposition(wrapper, 2),
    35: (wrapper) => reposition(wrapper, 3),
    45: (wrapper) => reposition(wrapper, 4)
  }
  // const TotalCorners = {
  //   init: (wrapper) => reposition(wrapper, 0),
  //   55: (wrapper) => reposition(wrapper, 0),
  //   65: (wrapper) => reposition(wrapper, 1),
  //   75: (wrapper) => reposition(wrapper, 2),
  //   85: (wrapper) => reposition(wrapper, 3),
  //   95: (wrapper) => reposition(wrapper, 4),
  //   105: (wrapper) => reposition(wrapper, 5),
  //   115: (wrapper) => reposition(wrapper, 6),
  //   125: (wrapper) => reposition(wrapper, 7),
  //   135: (wrapper) => reposition(wrapper, 8)
  // }
  // const Handicap = {
  //   init: (wrapper) => reposition(wrapper, 0),
  //   home_p1: (wrapper) => reposition(wrapper, 0),
  //   home_m1: (wrapper) => reposition(wrapper, 1),
  //   home_p2: (wrapper) => reposition(wrapper, 2),
  //   home_m2: (wrapper) => reposition(wrapper, 3),
  //   home_p3: (wrapper) => reposition(wrapper, 4),
  //   home_m3: (wrapper) => reposition(wrapper, 5),
  //   home_p4: (wrapper) => reposition(wrapper, 6),
  //   home_m4: (wrapper) => reposition(wrapper, 7),
  //   away_p1: (wrapper) => reposition(wrapper, 8),
  //   away_m1: (wrapper) => reposition(wrapper, 9),
  //   away_p2: (wrapper) => reposition(wrapper, 10),
  //   away_m2: (wrapper) => reposition(wrapper, 11),
  //   away_p3: (wrapper) => reposition(wrapper, 12),
  //   away_m3: (wrapper) => reposition(wrapper, 13),
  //   away_p4: (wrapper) => reposition(wrapper, 14),
  //   away_m4: (wrapper) => reposition(wrapper, 15),
  //   draw_p1: (wrapper) => reposition(wrapper, 16),
  //   draw_m1: (wrapper) => reposition(wrapper, 17),
  //   draw_p2: (wrapper) => reposition(wrapper, 18),
  //   draw_m2: (wrapper) => reposition(wrapper, 19),
  //   draw_p3: (wrapper) => reposition(wrapper, 20),
  //   draw_m3: (wrapper) => reposition(wrapper, 21),
  //   draw_p4: (wrapper) => reposition(wrapper, 22),
  //   draw_m4: (wrapper) => reposition(wrapper, 23)
  // }
  // const CorrectScore = {
  //   init: (wrapper) => reposition(wrapper, 0),
  //   s_0_0: (wrapper) => reposition(wrapper, 0),
  //   s_0_1: (wrapper) => reposition(wrapper, 1),
  //   s_0_2: (wrapper) => reposition(wrapper, 2),
  //   s_0_3: (wrapper) => reposition(wrapper, 3),
  //   s_0_4: (wrapper) => reposition(wrapper, 4),
  //   s_1_0: (wrapper) => reposition(wrapper, 5),
  //   s_1_1: (wrapper) => reposition(wrapper, 6),
  //   s_1_2: (wrapper) => reposition(wrapper, 7),
  //   s_1_3: (wrapper) => reposition(wrapper, 8),
  //   s_1_4: (wrapper) => reposition(wrapper, 9),
  //   s_2_0: (wrapper) => reposition(wrapper, 10),
  //   s_2_1: (wrapper) => reposition(wrapper, 11),
  //   s_2_2: (wrapper) => reposition(wrapper, 12),
  //   s_2_3: (wrapper) => reposition(wrapper, 13),
  //   s_2_4: (wrapper) => reposition(wrapper, 14),
  //   s_3_0: (wrapper) => reposition(wrapper, 15),
  //   s_3_1: (wrapper) => reposition(wrapper, 16),
  //   s_3_2: (wrapper) => reposition(wrapper, 17),
  //   s_3_3: (wrapper) => reposition(wrapper, 18),
  //   s_3_4: (wrapper) => reposition(wrapper, 19),
  //   s_4_0: (wrapper) => reposition(wrapper, 20),
  //   s_4_1: (wrapper) => reposition(wrapper, 21),
  //   s_4_2: (wrapper) => reposition(wrapper, 22),
  //   s_4_3: (wrapper) => reposition(wrapper, 23),
  //   s_4_4: (wrapper) => reposition(wrapper, 24)
  // }

  /**
   * Hides all bet columns expect the selected one.
   * Used for small screens only.
   * @param {string} market e.g. winner, btts, etc.
   * @param {NodeList} prices NodeList of .se-prices__winner or .se-prices__btts, etc.
   * @param {string} bet home, away, etc.
   */
  const changeBetOnMarketChange = (market, prices, bet = 'init') => {
    if (market === 'winner' || market === 'winnerH1' || market === 'winnerH2') {
      prices.forEach(s => Winner[bet](s))
    }
    if (market === 'btts') {
      prices.forEach(s => Btts[bet](s))
    }
    if (market === 'ttsf' || market === 'ttsl') {
      prices.forEach(s => Tts[bet](s))
    }
    if (market === 'doubleChance') {
      prices.forEach(s => DoubleChance[bet](s))
    }
    if (market === 'totalGoals') {
      prices.forEach(s => TotalGoals[bet](s))
    }
    // if (market === 'totalCorners') {
    //   prices.forEach(s => TotalCorners[bet](s))
    // }
    // if (market === 'correctScore') {
    //   prices.forEach(s => CorrectScore[bet](s))
    // }
    // if (market === 'handicap') {
    //   prices.forEach(s => Handicap[bet](s))
    // }
  }

  /**
   * Display only bets available in the selected market.
   * e.g. hide Yes, No options when the market is Winner.
   * Used for small screens only.
   * @param {HTMLSelectElement} select Select element containing all bet types
   * @param {string} market winner, btts, etc.
   */
  const setBetSelectOptions = (select, market) => {
    select.dataset.market = market
    const options = select.querySelectorAll('li')
    options.forEach(option => {
      option.removeAttribute('hidden')
      option.dataset.market === market
        ? option.removeAttribute('hidden')
        : option.setAttribute('hidden', 'hidden')
    })
    const marketOptions = Array.from(options).filter(o => !o.getAttribute('hidden'))
    if (marketOptions.length) {
      select.querySelector('.se-dropdown__value').innerText = marketOptions[0].innerText
    }
  }

  /**
   * Display only one market prices in the beginning.
   * Hides all other market prices except the first one.
   * @param {NodeList} prices NodeList of .se-prices elements.
   */
  const showOnlyOneMarket = prices => {
    prices.forEach(price => {
      const markets = Array.from(price.querySelectorAll('div[class^="se-prices__"]'))
      markets.shift()
      markets.forEach(market => market.classList.add('se-hidden'))
    })
  }

  /**
   * Display only first 2 bookmaker prices in the beginning.
   * Hides all other prices.
   * @param {NodeList} prices NodeList of .se-prices__winner, etc. elements.
   */
  const showOnlyInitialPrices = (prices, count = 2) => {
    prices.forEach((price, idx) => idx > count && price.classList.add('se-hidden'))
  }

  /**
   * Display all prices at once.
   * This never happens, it's just for adding/removing classnames.
   * @param {NodeList} prices NodeList of .se-prices__winner, etc. elements.
   */
  const showAllPrices = prices => prices.forEach(price => price.classList.remove('se-hidden'))

  /**
   * Change more/fewer prices button text.
   * @param {HTMLButtonElement} button Button with show more/less text.
   * @param {string} state more or less
   */
  const toggleShowMorePricesButtonState = (button, state) => {
    button.dataset.show = state
    button.querySelector('span').innerText = button.dataset[state]
  }

  /**
   * When the page is loaded, resized or orientation was changed,
   * we need to do some adjustments.
   * @param {HTMLDivElement} fixture .se-fixture
   * @param {HTMLSelectElement} select contains options for all bet types for all markets
   */
  const shiftLayoutToSmall = (fixture, select) => {
    const marketOnLoad = select.dataset.market
    const marketPrices = fixture.querySelectorAll(`.se-prices__${marketOnLoad}`)
    changeBetOnMarketChange(marketOnLoad, marketPrices)
    setBetSelectOptions(select, marketOnLoad)
    select.parentElement.classList.remove('se-hidden')
  }

  const hideChangeBetSelect = select => select.parentElement.classList.add('se-hidden')

  // Display the tables.
  const wrappers = document.querySelectorAll('.se-wrapper')
  if (wrappers.length) {
    wrappers.forEach(wrapper => {
      const league = wrapper.dataset.league
      const bookmakers = wrapper.dataset.bookmakers
      const markets = wrapper.dataset.markets
      const fixture = wrapper.dataset.fixture

      const params = new URLSearchParams()
      params.append('action', 'se-fetch-fixtures')
      params.append('league', league)
      params.append('bookmakers', bookmakers)
      params.append('markets', markets)
      params.append('fixture', fixture)

      window.fetch(Sibet.ajaxUrl, { // eslint-disable-line
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
        body: params
      })
        .then(response => response.json())
        .then(data => {
          wrapper.innerHTML = data.html

          const fixtures = document.querySelectorAll('.se-fixture')
          if (fixtures.length) {
            const initialPriceCount = parseInt(wrapper.dataset.initial) || 2

            fixtures.forEach(fixture => {
              const prices = fixture.querySelectorAll('.se-prices')

              showOnlyOneMarket(prices)

              if (prices.length > initialPriceCount + 1) {
                showOnlyInitialPrices(prices, initialPriceCount)

                const showMorePricesButton = fixture.querySelector('.se-prices--toggle')
                if (showMorePricesButton) {
                  showMorePricesButton.addEventListener('click', (e) => {
                    if (showMorePricesButton.dataset.show !== 'more') {
                      showAllPrices(prices)
                      toggleShowMorePricesButtonState(showMorePricesButton, 'more')
                    } else {
                      showOnlyInitialPrices(prices, initialPriceCount)
                      toggleShowMorePricesButtonState(showMorePricesButton, 'less')
                    }
                  })
                }
              }

              const changeMarketDropDown = fixture.querySelector('.se-prices--market .se-dropdown')
              const changeBetDropDown = fixture.querySelector('.se-prices--bet .se-dropdown')

              // when we change winner to btts, for example
              changeMarketDropDown.addEventListener('dropdownchange', (e) => {
                const market = e.detail.el.dataset.value
                changeMarketDropDown.dataset.value = market
                console.log(market)

                // we hide all market prices except the selected one
                fixture.querySelectorAll('.se-prices > div[class^="se-prices__"]')
                  .forEach(price => {
                    price.classList.contains(`se-prices__${market}`)
                      ? price.classList.remove('se-hidden')
                      : price.classList.add('se-hidden')
                  })

                // also if we're on a small screen, we need to
                // display the proper prices and change the bet select options
                if (window.innerWidth < 768) { // FIX. screen size detection here
                  const marketPrices = fixture.querySelectorAll(`.se-prices__${market}`)
                  if (marketPrices.length) {
                    changeBetOnMarketChange(market, marketPrices)
                  }

                  setBetSelectOptions(changeBetDropDown, market)
                } else {
                  hideChangeBetSelect(changeBetDropDown)
                }
              })

              // when we change home to draw for example
              changeBetDropDown.addEventListener('dropdownchange', (e) => {
                const market = changeBetDropDown.dataset.market
                const bet = e.detail.el.dataset.value
                changeBetDropDown.dataset.value = bet
                const marketPrices = fixture.querySelectorAll(`.se-prices__${market}`)
                changeBetOnMarketChange(market, marketPrices, bet)
              })

              // if we're on a small screen, we need to
              // display the proper prices and change the bet select options
              // "un-hide" the change bets select element
              if (window.innerWidth < 768) { // FIX. screen size detection here
                shiftLayoutToSmall(fixture, changeBetDropDown)
              }
            })
          }
        })
        .catch(error => console.log(error))
    })
  }
})()
